/**
 * autoGrowthRecompute (Jose 2026-10-11) — makes the Growth snapshot (and therefore the BPI's COMPUTED
 * factors, which read from it) refresh itself instead of waiting for the manual "↻ Recompute Growth"
 * button. Runs the SAME proven `recomputeAllFromLiveData` (no parallel server implementation = no drift
 * from the pay/growth math), throttled to ~once/day per device. Fire-and-forget; the manual button stays
 * as an "update now" override. (A true 3am server cron that runs with nobody logged in would require
 * porting the whole client engine server-side — deliberately deferred to avoid engine divergence.)
 */
import { recomputeAllFromLiveData } from './growthMetricsService';

const KEY = 'slik_growth_autorecompute_at';
const MIN_MS = 20 * 60 * 60 * 1000; // ~once/day
let running = false;

/** Recompute every barber's Growth snapshot if it hasn't run in ~20h. Returns true if it actually ran. */
export async function maybeAutoRecomputeGrowth(): Promise<boolean> {
  if (running) return false;
  try {
    const last = Number(localStorage.getItem(KEY) || 0);
    if (last && Date.now() - last < MIN_MS) return false;
  } catch { /* no localStorage → fall through and run */ }
  running = true;
  try {
    await recomputeAllFromLiveData();
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* private mode */ }
    // eslint-disable-next-line no-console
    console.log('[growth] auto-recomputed (daily)');
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[growth] auto-recompute skipped:', e);
    return false;
  } finally {
    running = false;
  }
}
